module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAYCAYAAACFms+HAAAAAXNSR0IArs4c6QAAARdJREFUWAnV1VEOQzAYwHGVEteY89ghePC6I2yP2xGQcIdxFXt0DhHRfWsiaaSsNdPPXnQm9mv9U5a10ydJkmeWZaet/s7e6kYK9zkzxl6AvxZF4Slcv3jJnnAL4N4wDLeu6+o0TYNF2Zcfd4ULFh8mUQK+zPPcF84rD03BORDwQd/39Zp8jMI/+rX5GIcLbWjlgwmulQ+B/ZUJs8Y2bAghlziOqykM3YpPgLP5YIfzech2H+ypTB4A/8rzOcSKi3ponti2Tah4EvMYvC0k83Ac5x6GYXsIOKArSukliqJmXFzs8NntkIwz+PdR530xZuG6Ls9CZkO34rIssMNns0AJV8kCHVw1C0xwrSyMw9dmYRT+SxYy+Bv/YqC8AOZsTQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/examtest_icon_next.png
// module id = BI7u
// module chunks = 0